import React, { useEffect, useState } from "react";
import binace from "../../images/bafrnd.png";
import creatorImage from "../../images/crtr.png";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import BuyNFTPopup from "../buy-nft";
import ResalePopup from "../buy-nft/resale-popup";
import ReturnPhysicalCopyPopup from "../buy-nft/physical-asset-return-popup";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
  addToast,
  Tooltip
} from "@heroui/react";
import { formatWalletAddress, getDaysAgoText } from "../../utils/common";
import NftCard from "../nft-card";
import {
  NFTCollectionsList,
  NFTRelatedCollectionsList,
  SettingsApi
} from "../../api/methods-marketplace";
import { ethers } from "ethers";
import { useSelector } from "react-redux";
import TrackPackagePopup from "../buy-nft/track-package";
import signSellOrder from "../../utils/signSellOrder";
import NftCardLoader from "../nft-card/nft-card-loader";
import { useWallet } from "../../context/WalletContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CardDetails = ({ slug, item, fetchItemDetails = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isConnected,
    connectWallet,
    address,
    hasAddressMismatch,
    disconnectWallet,
    isCustodialWallet,
    publicClient
  } = useWallet();
  const userBalance = useSelector((state) => state?.user?.balance);
  const [loading, setLoading] = useState(false);
  const [nftAddress, setNftAddress] = useState(null);
  const [erc20BAFAddress, setErc20BAFAddress] = useState(null);
  const [tradeContractAddress, setTradeContractAddress] = useState(null);
  const [buyerPlatformFee, setBuyerPlatformFee] = useState(null);
  const [sellerPlatformFee, setSellerPlatformFee] = useState(null);
  const [transferProxyAddress, setTransferProxyAddress] = useState(null);
  const [isTradable, setIsTradable] = useState(null);
  const [metadata, setMetadata] = useState(null);
  const [relatedProdList, setRelatedProdList] = useState([]);
  const [isNftProdListLoading, setIsNftProdListLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isResaleOpen, setIsResaleOpen] = useState(false);
  const [isReturnOpen, setIsReturnOpen] = useState(false);
  const [isTrackPopupOpen, setsTrackPopupOpen] = useState(false);

  const contract_id = item?.data?.collection?.nft_contract_id;
  const put_on_sale =
    item?.data?.collection?.put_on_sale === "true" ||
    item?.data?.collection?.put_on_sale === true;
  const { user } = useSelector((state) => state);
  const isUserLogged = user?.login;
  const meta_hash = item?.data?.collection.metadata_hash;
  const isOwner =
    item?.data?.collection?.owner?.address?.toLowerCase() ===
    address?.toLowerCase();
  const resalePrice = item?.data?.collection?.resale_price;
  const testScan_link = `https://testnet.bscscan.com/tx/${item?.data?.collection?.transaction_hash}`;
  const transaction_hash = item?.data?.collection?.transaction_hash;
  const ownerAddress = item?.data?.collection?.owner?.address;
  const createdAt = item?.data?.collection?.owner?.created_at;
  const collectionType = item?.data?.collection?.collection_type;
  const collection_type = collectionType === "single" ? "NFT 721" : "NFT 1155";
  const sale_status = item?.data?.collection.sale_status;
  const physical_asset = item?.data?.collection?.physical_nft;
  const isPhysicalAsset = physical_asset === "true" || physical_asset === true;
  const trackDetails = item?.data?.shipping_status;
  const isDelivered = trackDetails === "delivered";
  const image_hash = item?.data?.collection.image_hash;
  const imgSrc = `https://ipfs.io/ipfs/${image_hash}`;
  const inUSD =
    item?.data?.collection?.instant_sale_price_in_usd &&
    item?.data?.collection?.instant_sale_price_in_usd !== 0;
  const inBAF =
    item?.data?.collection?.resale_price ||
    item?.data?.collection?.instant_sale_price;
 const isNewNFT = sale_status === "new_nft" && isTradable;
  const canListForSale =
    (sale_status === "purchased" && !isPhysicalAsset && isTradable) ||
    (sale_status === "sale_approved" && !put_on_sale && isTradable);

  const isResale =
    (sale_status === "purchased" &&
      isPhysicalAsset &&
      isDelivered &&
      !put_on_sale) ||
    (sale_status === "sale_rejected" && isTradable) ||
    (sale_status === "purchased" &&
      !isPhysicalAsset &&
      !resalePrice &&
      isTradable) ||
    (isNewNFT && !put_on_sale);

  const trackStatus =
    (sale_status === "purchased" && isPhysicalAsset && !isDelivered) ||
    (sale_status === "evaluate" && isPhysicalAsset);

  const canShowActionButton =
    isOwner &&
    isConnected &&
    (isTradable ||
      (!isTradable && !isDelivered) ||
      (sale_status === "evaluate" && isPhysicalAsset)) &&
    user?.data?.address;

  const canShowNonTradable = isOwner && !isTradable && isTradable !== null;
  const updateAddress = isOwner && !user?.data?.address;
  const buyButton = !isOwner && isConnected && put_on_sale;
  const checkDisconnect =
    (!user?.data?.address && address) || hasAddressMismatch;
  const walletConnect = !isConnected && isUserLogged;

  const isDisabled =
    sale_status === "new_nft" ||
    put_on_sale ||
    (!isTradable && !isPhysicalAsset) ||
    (!isTradable && physical_asset && isDelivered);

  const isWalletMust = !isConnected && !address && !isCustodialWallet;

  const handleDisconnectWallet = () => {
    disconnectWallet();
  };

  const handleBuyClick = () => {
    if (user?.login) {
      setIsPopupOpen((prev) => !prev);
      // window.location.reload();
    } else {
      navigate("/login");
    }
  };

  const handleResaleClick = (open) => {
    setIsResaleOpen(open);
  };

  const handleSuccess = () => {
    // setIsResaleOpen((prev) => !prev);
    addToast({
      title: "Success",
      description: "Resale successful",
      color: "success",
      variant: "bordered"
    });
    window.location.reload();
  };

  const handleTrackClick = () => {
    setsTrackPopupOpen(!isTrackPopupOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (isWalletMust) {
        addToast({
          title: "Connect your wallet",
          description: "Please connect your wallet",
          color: "warning",
          variant: "bordered"
        });
        return;
      }
    };

    fetchData();
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWalletMust]);

  const handleModalChange = () => {
    setIsPopupOpen((prev) => !prev);
  };

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const settings = await SettingsApi();

      const getAddressById = (contract_id) => {
        return settings.data.nft_contracts.find((nft) => nft.id === contract_id)
          ?.address;
      };
      const getAddressByType = (contract_id) => {
        return settings.data.nft_contracts.find((nft) => nft.id === contract_id)
          ?.contract_type;
      };

      const nft_address = getAddressById(contract_id);
      const tradable = getAddressByType(contract_id);

      if (tradable === "tradable") {
        setIsTradable(true);
      } else {
        setIsTradable(false);
      }

      const erc20 = Object.fromEntries(
        settings.data.erc20_contracts.map((token) => [
          token.symbol,
          token.address
        ])
      );

      // const owner_address = settings?.data?.ownerAddress ? settings?.data?.ownerAddress : null
      const tradeContract = settings?.data?.tradeContractAddress
        ? settings?.data?.tradeContractAddress
        : null;
      const transferProxy = settings?.data?.transferProxyContractAddress
        ? settings?.data?.transferProxyContractAddress
        : null;

      const seller_platform_fee = settings?.data?.seller_platform_fees
        ? settings?.data?.seller_platform_fees
        : null;
      const buyer_platform_fee = settings?.data?.buyer_platform_fees
        ? settings?.data?.buyer_platform_fees
        : null;

      setNftAddress(nft_address);
      setBuyerPlatformFee(buyer_platform_fee);
      setSellerPlatformFee(seller_platform_fee);
      setErc20BAFAddress(erc20.PMT);
      setTradeContractAddress(tradeContract);
      setTransferProxyAddress(transferProxy);
      setLoading(false);
    } catch (err) {
      console.log("🚀 ~ fetchSettings ~ err:", err);
    }
  };

  const handleSignSellOrder = () => {
    if (!resalePrice && !isPhysicalAsset) {
      setIsResaleOpen(true);
    } else {
      signSellOrder({
        slug,
        item,
        erc20BAFAddress,
        nftAddress,
        transferProxyAddress,
        isCustodialWallet,
        address,
        publicClient
      });
    }
  };

  const buttonHandler = trackStatus
    ? handleTrackClick
    : isResale
      ? handleResaleClick
      : canListForSale
        ? handleSignSellOrder
        : undefined;

  const buttonLabel = trackStatus
    ? "Track Details"
    : isResale
      ? "Resale"
      : canListForSale
        ? "List For Sale"
        : isNewNFT
          ? "Listed For Sale"
          : !isTradable
            ? "Non-Tradable"
            : "OOPS!";

  useEffect(() => {
    const fetchMetadata = async () => {
      if (!meta_hash) return;

      try {
        const response = await fetch(`https://ipfs.io/ipfs/${meta_hash}`);
        const data = await response.json();
        setMetadata(data);
      } catch (error) {
        console.error("Error fetching metadata:", error);
      }
    };

    fetchMetadata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta_hash]);

  const handleRelatedProd = async () => {
    setIsNftProdListLoading(true);
    try {
      const result = await NFTRelatedCollectionsList(slug);
      if (result) {
        setRelatedProdList(result.data.data);
        setIsNftProdListLoading(false);
      }
    } catch (err) {
      console.log("🚀 ~ handleCardCollection ~ err:", err);
      setIsNftProdListLoading(false);
    } finally {
      setIsNftProdListLoading(false);
    }
  };

  useEffect(() => {
    handleRelatedProd();
  }, []);

  const ArrowUpRightIcon = () => (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-3 h-3"
    >
      <path
        d="M9.86892 1.12496V5.50926C9.86892 5.99253 9.47723 6.38423 8.99397 6.38423C8.51071 6.38423 8.11902 5.99253 8.11902 5.50926V3.23733L1.49378 9.49382C1.32289 9.66456 1.09887 9.75 0.875 9.75C0.651132 9.75 0.427111 9.66456 0.256225 9.49367C-0.0855488 9.15204 -0.0855488 8.59788 0.256225 8.25626L6.88146 1.99992H4.60969C4.12643 1.99992 3.73474 1.60823 3.73474 1.12496C3.73474 0.641696 4.12643 0.25 4.60969 0.25H8.99397C9.47723 0.25 9.86892 0.641696 9.86892 1.12496Z"
        fill="black"
      />
    </svg>
  );
  return (
    <div className="px-4  max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 xl:gap-24 py-8 lg:py-16">
        <div className="lg:w-[50%] xl:w-[40%]">
          <div className="img-wrapper">
            <div className="w-full flex items-center justify-between gap-4 bg-yellowbuy py-2 px-4 rounded-t-2xl">
              <img
                src={binace}
                alt="Binance Icon"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div className="w-full image-container rounded-b-2xl overflow-hidden">
              <img
                src={imgSrc}
                alt="NFT"
                className="object-cover w-full h-[auto]"
              />
            </div>
          </div>
        </div>
        <div className="lg:w-[50%] xl:w-[60%] relative">
          <div className="absolute right-0 top-0">
            <Dropdown placement="bottom-end">
              <DropdownTrigger>
                <button className="bg-white border-0">
                  <PiDotsThreeOutlineFill className="w-6 h-6 !min-w-6" />
                </button>
              </DropdownTrigger>
              <DropdownMenu aria-label="Profile Actions" variant="flat">
                {transaction_hash && (
                  <DropdownItem
                    key="view_on_bsc"
                    as={"a"}
                    href={testScan_link}
                    target="_blank"
                    endContent={<ArrowUpRightIcon />}
                  >
                    View on BSCscan
                  </DropdownItem>
                )}
                <DropdownItem
                  key="view_on_ipfs"
                  as={"a"}
                  href={imgSrc}
                  target="_blank"
                  endContent={<ArrowUpRightIcon />}
                >
                  View on IPFS
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="nft-details-wrapper flex flex-col gap-4 lg:max-w-[30rem]">
            <div className="flex flex-col gap-1.5">
              <h1 className="m-0 text-2xl sm:text-4xl font-bold text-black">
                {item?.data?.collection?.name}
              </h1>
              <div className="flex flex-wrap gap-2 my-3">
                {isPhysicalAsset ? (
                  <span className="inline-flex items-center rounded-[5rem] bg-lytyellow bg-opacity-25 px-3 py-1 text-xs font-medium text-dark ring-1 ring-[#cbb702] ring-inset">
                    #Physical
                  </span>
                ) : (
                  <span className="inline-flex items-center rounded-[5rem] bg-lytyellow bg-opacity-25 px-3 py-1 text-xs font-medium text-dark ring-1 ring-[#cbb702] ring-inset">
                    #Digital
                  </span>
                )}
                {isTradable ? (
                  <span className="inline-flex items-center rounded-[5rem] bg-lytyellow bg-opacity-25 px-3 py-1 text-xs font-medium text-dark ring-1 ring-[#cbb702] ring-inset">
                    #Tradable
                  </span>
                ) : (
                  <span className="inline-flex items-center rounded-[5rem] bg-lytyellow bg-opacity-25 px-3 py-1 text-xs font-medium text-dark ring-1 ring-[#cbb702] ring-inset">
                    #Non-Tradable
                  </span>
                )}
              </div>
              <p className="m-0 text-base leading-6 text-black">
                {item?.data?.collection?.description}
              </p>
              <div className="flex items-center gap-2">
                {inBAF && (
                  <h6 className="m-0 text-xl font-medium text-black">
                    {item?.data?.collection?.resale_price
                      ? item?.data?.collection?.resale_price
                      : item?.data?.collection?.instant_sale_price}{" "}
                    BAF
                  </h6>
                )}
                {inBAF && inUSD && (
                  <p className="m-0 text-[#0000009C] text-base font-bold leading-[1.5]">
                    ~${item?.data?.collection?.instant_sale_price_in_usd}
                  </p>
                )}
              </div>
            </div>

            {loading ? (
              <div className="flex items-center w-full">
                <Button
                  className="bg-yellowbuy border border-black !max-w-[13rem] w-full font-normal rounded-lg disabled:opacity-50 disabled:bg-[#D3D3D3]"
                  disabled={true}
                  radius="none"
                >
                  Loading...
                </Button>
              </div>
            ) : buyButton ? (
              <div className="flex items-center w-full gap-2">
                {checkDisconnect ? (
                  <>
                    <Tooltip
                      color="warning"
                      content="Wallet address belongs to another account. Please reconnect with the correct one."
                      showArrow
                      classNames={{
                        content: "max-w-[280px] text-sm leading-5"
                      }}
                    >
                      <Button
                        className="bg-yellowbuy border border-black font-normal !max-w-[13rem] w-full"
                        radius="lg"
                        onPress={handleDisconnectWallet}
                      >
                        {!hasAddressMismatch
                          ? "Update Address to Buy"
                          : "Address Mismatch"}
                      </Button>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <Button
                      className={`${
                        hasAddressMismatch ? "bg-[#C0C0C0]" : "bg-yellowbuy"
                      } border border-black font-normal !max-w-[13rem] w-full rounded-lg`}
                      onPress={handleBuyClick}
                      radius="none"
                      disabled={hasAddressMismatch}
                    >
                      Buy Now
                    </Button>
                  </>
                )}
              </div>
            ) : canShowActionButton ? (
              <div className="flex items-center w-full">
                <Button
                  className="bg-yellowbuy border border-black !max-w-[13rem] w-full font-normal rounded-lg disabled:opacity-50 disabled:bg-[#D3D3D3]"
                  onPress={buttonHandler}
                  disabled={isDisabled}
                  radius="none"
                >
                  {buttonLabel}
                </Button>
              </div>
            ) : updateAddress ? (
              <>
                <Tooltip
                  color="warning"
                  content="Wallet address belongs to another account. Please reconnect with the correct one."
                  showArrow
                  classNames={{
                    content: "max-w-[280px] text-sm leading-5"
                  }}
                >
                  <Button
                    className="bg-yellowbuy border border-black font-normal !max-w-[13rem] w-full"
                    radius="lg"
                    onPress={handleDisconnectWallet}
                  >
                    Update Address
                  </Button>
                </Tooltip>
              </>
            ) : walletConnect ? (
              <div className="flex items-center w-full">
                <Button
                  className="bg-yellowbuy border border-black !max-w-[13rem] w-full font-normal rounded-lg"
                  onPress={() => connectWallet()}
                  radius="none"
                >
                  Connect Wallet
                </Button>
              </div>
            ) : canShowNonTradable ? (
              <div className="flex items-center w-full">
                <Button
                  className="bg-yellowbuy border border-black !max-w-[13rem] w-full font-normal rounded-lg disabled:opacity-50 disabled:bg-[#D3D3D3]"
                  disabled={true}
                  radius="none"
                >
                  Non-Tradable
                </Button>
              </div>
            ) : (
              !isUserLogged && (
                <div className="flex items-center w-full">
                  <Button
                    className="bg-yellowbuy border border-black !max-w-[13rem] w-full font-normal rounded-lg"
                    onPress={() =>
                      navigate("/login", {
                        state: {
                          from: location.pathname + location.search
                        }
                      })
                    }
                    radius="none"
                  >
                    Login to Buy
                  </Button>
                </div>
              )
            )}

            <div className="flex flex-wrap gap-2">
              <div className="border border-[#C2C2C2] py-2 px-4 rounded-xl flex flex-col gap-2 w-full md:w-[calc(50%-0.5rem)]">
                <h6 className="m-0 text-base text-black font-blod">Creator</h6>
                <div className="flex items-center gap-2">
                  <div className="icon w-[3rem] h-[3rem]">
                    <img
                      src={creatorImage}
                      alt="creator"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="m-0 text-base leading-6 text-black w-[calc(100%-3.5rem)] break-all">
                    {formatWalletAddress(
                      item?.data?.collection.creator?.address
                    )}
                  </p>
                </div>
              </div>
              <div className="border border-[#C2C2C2] py-2 px-4 rounded-xl flex flex-col gap-2 w-full md:w-[calc(50%-0.5rem)]">
                <h6 className="m-0 text-base text-black font-blod">
                  Collections
                </h6>
                <div className="flex items-center gap-2">
                  <div className="icon w-[3rem] h-[3rem]">
                    <img
                      src={creatorImage}
                      alt="creator"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="m-0 text-base leading-6 text-black w-[calc(100%-3.5rem)] break-all">
                    {collection_type}
                  </p>
                </div>
              </div>
              <div className="border border-[#C2C2C2] py-2 px-4 rounded-xl flex flex-col gap-2 w-full">
                <h6 className="m-0 text-base text-black font-blod">History</h6>
                <div className="flex items-center gap-2">
                  <div className="icon w-[3rem] h-[3rem]">
                    <img
                      src={creatorImage}
                      alt="creator"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-[calc(100%-3.5rem)] flex flex-col gap-1">
                    <h6 className="m-0 text-base leading-6 text-black break-all font-bold">
                      {getDaysAgoText(createdAt)}
                    </h6>
                    <p className="m-0 text-base leading-6 text-black break-all">
                      {formatWalletAddress(ownerAddress)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="related-product_section">
        <div className="flex items-center justify-between gap-4">
          <h1 className="m-0 text-xl sm:text-2xl sm:text-4xl font-semibold text-black uppercase">
            Related Products
          </h1>
        </div>

        {isNftProdListLoading || relatedProdList.length > 0 ? (
          <div className="w-full my-8 relative">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={16}
              navigation={false}
              pagination={false}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 }
              }}
            >
              {isNftProdListLoading
                ? [...Array(4)].map((_, index) => (
                    <SwiperSlide key={index}>
                      <NftCardLoader />
                    </SwiperSlide>
                  ))
                : relatedProdList
                    .filter(
                      (collection) => collection.instant_sale_price !== null
                    )
                    .slice(0, 20)
                    .map((collection, index) => (
                      <SwiperSlide key={index}>
                        <div className="max-w-sm mx-auto">
                          <NftCard data={collection} />
                        </div>
                      </SwiperSlide>
                    ))}
            </Swiper>
          </div>
        ) : (
          <div className="w-full my-8">
            <p className="text-gray-500 text-center">
              No related products available.
            </p>
          </div>
        )}
      </div>

      {isReturnOpen && (
        <ReturnPhysicalCopyPopup onClose={() => setIsReturnOpen(false)} />
      )}
      {isResaleOpen && (
        <ResalePopup
          isOpen={isResaleOpen}
          item={item}
          onOpenChange={handleResaleClick}
          onResaleSuccess={handleSuccess}
        />
      )}

      {isPopupOpen && (
        <BuyNFTPopup
          item={item}
          buyerPlatformFee={buyerPlatformFee}
          sellerPlatformFee={sellerPlatformFee}
          nftAddress={nftAddress}
          erc20BAFAddress={erc20BAFAddress}
          tradeContractAddress={tradeContractAddress}
          transferProxyAddress={transferProxyAddress}
          onOpenChange={handleModalChange}
          user_balance={userBalance}
          isOpen={isPopupOpen}
          metadata={metadata}
          fetchNftData={fetchItemDetails}
        />
      )}
      {isTrackPopupOpen && (
        <TrackPackagePopup
          isOpen={isTrackPopupOpen}
          onOpenChange={handleTrackClick}
          nftImage={imgSrc}
        />
      )}
    </div>
  );
};

export default CardDetails;
